import Slider from 'react-slick';

const SlickCarouselArrow = ({ side, onClick, className }) => {
  return (
    <div
      className={`${className ?? ''} shadow-md rounded-lg custom-slick-arrow cursor-pointer bg-white hover:bg-gray-50 transition-colors duration-200`}
      onClick={onClick}
      style={{
        [side]: '-0.75rem',
      }}
    >
      <i className={`fas fa-angle-${side} text-gray-700`} />
    </div>
  );
};

const SlickImageGallery = ({ items, customSettings }) => {
  if (!items?.length) return null;

  const settings = {
    dots: items.length > 1,
    dotsClass: 'slick-dots slick-thumb',
    infinite: items.length > 1,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    touchThreshold: 100,
    prevArrow: <SlickCarouselArrow side='left' />,
    nextArrow: <SlickCarouselArrow side='right' />,
    customPaging: function (i) {
      return (
        <div style={{ width: '60px', height: '60px', margin: '0 5px' }}>
          <img
            alt={`Thumbnail ${i}`}
            src={items[i]}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              borderRadius: '4px',
              cursor: 'pointer',
            }}
          />
        </div>
      );
    },
    ...customSettings,
  };

  return (
    <div className='gallery-slider'>
      <Slider {...settings}>
        {items?.map((item, index) => (
          <div key={`${item}-${index}`}>
            <img alt={item} className='main-img' src={item} loading='lazy' />
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default SlickImageGallery;
